module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/purdue-university-fea5839ef70fbfe3723f4bb96dc963e0.svg";